import Service from '../abstract/service'

export default class Tipos extends Service {

  constructor(tipo) {
    super()
    this.tipo = tipo
  }

  async update(tipoId, values) {
    try{
      this._loading.setLoading(true, "Atualizando dados")
      const tipoRef = await this._db.collection("gruposEmpresas")
      .doc("GrupoCometa")
      .collection(`${this.tipo}`)
      .doc(`${tipoId}`)
      tipoRef.update(values)
      return Promise.resolve()
    } catch(error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async create(values) {
    try {
      const tipoRef = await this._db.collection("gruposEmpresas")
      .doc("GrupoCometa")
      .collection(`${this.tipo}`)
      tipoRef.doc().set(values);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getTipoByEmpresas(empresas) {
    try {
      this._loading.setLoading(true, `Carregando ${this.tipo.charAt(0).toUpperCase() + this.tipo.slice(1)}`)
      let tiposArr = new Array()

      let response = await this._db.collection(`gruposEmpresas/GrupoCometa/${this.tipo}`)
      .where("empresas", "array-contains-any", empresas).get()

      for (const doc of response.docs) {
        tiposArr.push({
          id: doc.id,
          ...doc.data()
        })
      }
      return Promise.resolve(tiposArr)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getVeiculos(tipo) {
    try{
      this._loading.setLoading(true, "Carregando Veiculos")
      let veiculosArr = new Array()

      for (const veiculo of tipo.veiculos) {
        let response = await this._db.collection("gruposEmpresas")
        .doc("GrupoCometa")
        .collection("Veiculos")
        .doc(`${veiculo}`).get()
        veiculosArr.push({
          id: response.id,
          tipoId: tipo.id,
          ...response.data()
        })
      }
      return Promise.resolve(veiculosArr)
    } catch(error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getPrazos(tipo) {
    try{
      this._loading.setLoading(true, "Carregando Prazos")
      let prazoArr = new Array()

      let prazos = await this._db.collection(`gruposEmpresas/GrupoCometa/${this.tipo}/${tipo.id}/prazos`).get()
      prazos.docs.map(doc => prazoArr.push({
        id: doc.id,
        ...doc.data()
      }))
      return Promise.resolve(prazoArr)
    } catch(error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async removeVeiculo(veiculoId, tipo) {
    try {
      this._loading.setLoading(true, "Removendo Veiculo")
      const tipoRef = await this._db.collection("gruposEmpresas")
      .doc("GrupoCometa")
      .collection(`${this.tipo}`)
      .doc(`${tipo.id}`)
      tipo.veiculos = tipo.veiculos.filter(veiculo => veiculo !== veiculoId)
      tipoRef.update({veiculos: tipo.veiculos})
      return Promise.resolve()
    } catch(error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
